import React from 'react';
import { MobileMenuStyledDrawer } from './style';

export interface MobileMenuDrawerProps {
  open?: boolean;
  closable?: boolean;
  destroyOnClose?: boolean;
  children?: React.ReactNode;
  onClose?: (e: React.MouseEvent | React.KeyboardEvent) => void;
  footer?: React.ReactNode;
  title?: string | React.ReactNode;
  className?: string;
}

export const MobileMenuDrawer = ({
  open,
  children,
  destroyOnClose,
  closable = true,
  onClose,
  footer,
  title,
  className,
}: MobileMenuDrawerProps) => {
  return (
    <MobileMenuStyledDrawer
      className={className}
      id={'mobile-menu-drawer'}
      open={open}
      width={'100%'}
      destroyOnClose={destroyOnClose}
      getContainer={document.getElementById('app-root')!}
      closable={closable}
      onClose={onClose}
      footer={footer}
      placement={'bottom'}
      title={title}
      height={'100%'}
      styles={{
        content: { borderRadius: 15 },
        mask: { backgroundColor: 'transparent' },
        wrapper: {
          boxShadow: 'none',
          paddingBottom: 150,
          bottom: 0,
          height: 'max-content',
        },
      }}
      rootClassName="mobile-menu-root"
      zIndex={1005}
    >
      {children}
    </MobileMenuStyledDrawer>
  );
};
